(() => {
  const config = window.referenceCurrencyConfig;

  if (!config || !config.shopCurrency) return;

  const countryCurrencies = {
    AD: 'EUR', AE: 'AED', AT: 'EUR', AU: 'AUD', BE: 'EUR', BG: 'BGN', BH: 'BHD',
    BR: 'BRL', CA: 'CAD', CH: 'CHF', CN: 'CNY', CY: 'EUR', CZ: 'CZK', DE: 'EUR',
    DK: 'DKK', EE: 'EUR', ES: 'EUR', FI: 'EUR', FR: 'EUR', GB: 'GBP', GR: 'EUR',
    HK: 'HKD', HR: 'EUR', HU: 'HUF', ID: 'IDR', IE: 'EUR', IN: 'INR', IT: 'EUR',
    JP: 'JPY', KR: 'KRW', KW: 'KWD', LT: 'EUR', LU: 'EUR', LV: 'EUR', MC: 'EUR',
    MT: 'EUR', MX: 'MXN', MY: 'MYR', NL: 'EUR', NO: 'NOK', NZ: 'NZD', OM: 'OMR',
    PH: 'PHP', PL: 'PLN', PT: 'EUR', QA: 'QAR', RO: 'RON', SA: 'SAR', SE: 'SEK',
    SG: 'SGD', SI: 'EUR', SK: 'EUR', TH: 'THB', TR: 'TRY', TW: 'TWD', US: 'USD',
    VN: 'VND', ZA: 'ZAR'
  };

  let targetCurrency = config.shopCurrency;
  let refreshQueued = false;

  function formatReferencePrice(cents) {
    if (!window.Currency || !Currency.rates) return null;

    const shopRate = Currency.rates[config.shopCurrency];
    const targetRate = Currency.rates[targetCurrency];

    if (!shopRate || !targetRate) return null;

    const convertedAmount = (Number(cents) / 100) * (shopRate / targetRate);

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: targetCurrency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: targetCurrency === 'JPY' || targetCurrency === 'KRW' || targetCurrency === 'VND' ? 0 : 2
    }).format(convertedAmount);
  }

  function updateReferencePrices() {
    refreshQueued = false;

    document.querySelectorAll('[data-reference-price]').forEach((element) => {
      if (targetCurrency === config.shopCurrency) {
        element.hidden = true;
        element.textContent = '';
        return;
      }

      const formattedPrice = formatReferencePrice(element.dataset.referencePriceCents);

      if (!formattedPrice) {
        element.hidden = true;
        return;
      }

      const priceLine = document.createElement('span');
      priceLine.className = 'reference-price__amount';
      priceLine.textContent = `${config.approximateLabel} ${formattedPrice} ${targetCurrency}`;

      const checkoutLine = document.createElement('small');
      checkoutLine.className = 'reference-price__checkout-note';
      checkoutLine.textContent = config.checkoutNotice;

      element.replaceChildren(priceLine, checkoutLine);
      element.hidden = false;
    });
  }

  function queueReferencePriceUpdate() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(updateReferencePrices);
  }

  function detectedCountryEndpoint() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}browsing_context_suggestions.json?country[enabled]=true`;
  }

  async function detectCountry() {
    try {
      const cachedCountry = window.sessionStorage.getItem('asopalav_reference_country');
      if (cachedCountry) return cachedCountry;

      const response = await fetch(detectedCountryEndpoint(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Country detection unavailable');

      const data = await response.json();
      const country = data?.detected_values?.country?.handle || config.storefrontCountry;

      if (country) window.sessionStorage.setItem('asopalav_reference_country', country);
      return country;
    } catch (error) {
      return config.storefrontCountry;
    }
  }

  async function initializeReferenceCurrency() {
    const country = await detectCountry();
    targetCurrency = countryCurrencies[country] || config.shopCurrency;
    updateReferencePrices();

    const observer = new MutationObserver(queueReferencePriceUpdate);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', queueReferencePriceUpdate);
    document.addEventListener('variant:change', queueReferencePriceUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReferenceCurrency, { once: true });
  } else {
    initializeReferenceCurrency();
  }
})();
